import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id D670073A-229E-474A-BDF8-ED5F07C1FC41
 * name flag-off
 * version: 6.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/flag-off.svg
 * tags
 */
export const FlagOffIcon = createSvgIcon(<><path d="M20.84 22.73L14.11 16H13L12.72 14.61L12.11 14H7V21H5V6.89L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M20 16V6H14.4L14 4H7.2L19.2 16H20" /></>, 'FlagOffIcon');
export default FlagOffIcon